import { AuthLogoutRequestAction, AUTH_LOGOUT_REQUEST } from "auth";
import { SUBMIT_APP_END } from "../../../App/modules";
import {
    ADD_PAYMENT_ACCOUNT_END,
    ADD_PUBLISHING_ACCOUNT_END,
    ADD_USER_TO_ORGANIZATION_END,
    CREATE_ORGANIZATION_END, DELETE_PENDING_USER_END,
    FETCH_AVAILABLE_APPS_SUMMARY_END,
    FETCH_ORGANIZATION_END,
    FETCH_ORGANIZATION_LIST_END,
    FETCH_ORGANIZATION_USER_ANALYTICS_END,
    FETCH_PAYMENT_ACCOUNT_SUMMARY,
    FETCH_PAYMENT_ACCOUNT_SUMMARY_END,
    FETCH_USERS_OF_ORGANIZATION_END, OrgActions, REMOVE_USER_FROM_ORGANIZATION_END,
    SELECT_ORGANIZATION,
    UPDATE_ORGANIZATION_END,
    UPDATE_USER_ROLES_END,
    UPLOAD_ORG_ICON_CLEAR,
    UPLOAD_ORG_ICON_SUCCESS
} from "../actions";
import { OrgState } from "../state";
import { addUserToOrganization } from "./AddUserToOrganization";
import { createOrganization } from "./CreateOrganization";
import { deletePendingUser } from "./DeletePendingUser";
import { fetchAvailableAppsSummary } from "./FetchAvailableAppsSummary";
import { fetchOrganization } from "./FetchOrganization";
import { fetchOrganizationList } from "./FetchOrganizationList";
import { fetchOrganizationUserAnalytics } from "./FetchOrganizationUserAnalytics";
import { updateAccountSummary, updateAccountSummaryStart } from "./FetchPaymentAccontSummary";
import { removeUserFromOrganization } from "./RemoveUserFromOrganization";
import { selectOrganization } from "./SelectOrganization";
import { submitApp } from "./SubmitApp";
import { updateOrganization } from "./UpdateOrganization";
import { updateUserRoles } from "./UpdateUserRoles";
import { clearUploadedOrgIcon, uploadOrgIcon } from "./UploadOrganizationIcon";

const initialState: OrgState = {
    errors: {},
    loading: false,
    loadingAccountSummary: false,
    orgPages: [],
    orgs: undefined,
    pendingUsers: {},
    userAnalytics: {},
    users: {}
};

type PayloadAction = OrgActions & { payload?: { error?: Error } };

/* tslint:disable:cyclomatic-complexity */
export function orgReducer(state: OrgState = { ...initialState }, action: OrgActions): OrgState {
    const stateCopy = addError(state, action as PayloadAction);

    switch (action.type) {
        case AUTH_LOGOUT_REQUEST: {
            return logout(stateCopy, action);
        }

        case CREATE_ORGANIZATION_END: {
            return createOrganization(stateCopy, action);
        }

        case DELETE_PENDING_USER_END: {
            return deletePendingUser(stateCopy, action);
        }

        case SELECT_ORGANIZATION: {
            return selectOrganization(stateCopy, action);
        }
        // What is this?
        case FETCH_ORGANIZATION_END: {
            return fetchOrganization(stateCopy, action);
        }

        case FETCH_ORGANIZATION_LIST_END: {
            return fetchOrganizationList(stateCopy, action);
        }

        case SUBMIT_APP_END: {
            return submitApp(stateCopy, action);
        }

        case ADD_PAYMENT_ACCOUNT_END:
        case ADD_PUBLISHING_ACCOUNT_END:
        case UPDATE_ORGANIZATION_END: {
            return updateOrganization(stateCopy, action);
        }

        case FETCH_AVAILABLE_APPS_SUMMARY_END: {
            return fetchAvailableAppsSummary(stateCopy, action);
        }

        case FETCH_PAYMENT_ACCOUNT_SUMMARY: {
            return updateAccountSummaryStart(stateCopy);
        }

        case FETCH_PAYMENT_ACCOUNT_SUMMARY_END: {
            return updateAccountSummary(stateCopy, action);
        }

        case FETCH_ORGANIZATION_USER_ANALYTICS_END: {
            return fetchOrganizationUserAnalytics(stateCopy, action);
        }

        case REMOVE_USER_FROM_ORGANIZATION_END: {
            return removeUserFromOrganization(stateCopy, action);
        }

        case ADD_USER_TO_ORGANIZATION_END:
        case FETCH_USERS_OF_ORGANIZATION_END: {
            return addUserToOrganization(stateCopy, action);
        }

        case UPDATE_USER_ROLES_END: {
            return updateUserRoles(stateCopy, action);
        }

        case UPLOAD_ORG_ICON_SUCCESS: {
            return uploadOrgIcon(stateCopy, action);
        }

        case UPLOAD_ORG_ICON_CLEAR: {
            return clearUploadedOrgIcon(stateCopy, action);
        }

        default:
            return stateCopy;
    }
}
/* tslint:enable:cyclomatic-complexity */

function addError(state: OrgState, action: PayloadAction): OrgState {
    if (action.payload) {
        const errors = { ...state.errors, [action.type]: action.payload.error };
        return { ...state, errors };
    }
    return state;
}

function logout(state: OrgState, action: AuthLogoutRequestAction) {
    return { ...initialState };
}
